import React from 'react';

import styled from '@emotion/styled';

import { HoverDropDown } from '../../DropDown/HoverDropDown';
import MoreOptionsIcon from '../../Icons/MoreOptionsIcon';

interface TableMoreOptionsProps {
  moreOptionsComponents: React.ReactNode[];
  data?: any;
}

const TableMoreOptions: React.FC<TableMoreOptionsProps> = ({
  moreOptionsComponents,
  data,
}) => {
  const handleMoreOptionsOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };
  return (
    <Container onClick={handleMoreOptionsOnClick}>
      <HoverDropDown label={<MoreOptionsIcon />}>
        <OptionsContainer>
          {React.Children.map(moreOptionsComponents, (child: any) => {
            return React.cloneElement(child, { ...child.props, data: data });
          })}
        </OptionsContainer>
      </HoverDropDown>
    </Container>
  );
};

export default TableMoreOptions;

const Container = styled.div`
  position: absolute;
  top: calc(100%, -28px);
  right: -16px;
  cursor: pointer;
  /* border: 1px solid yellow; */
  /* overflow: hidden; */
  /* border: 1px solid blue; */
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: fit-content;
  background-color: white;
  padding: 4px 0;
  /* border: 1px solid green; */
  /* border: 1px solid red; */
`;
